/* Olive + M — Grove theme JS. Motion + smart nav + AJAX cart drawer + PDP. */
(function () {
  'use strict';
  const OM = window.OM || {};
  const RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const MOTION = OM.motion !== false && !RM;
  if (!MOTION) document.documentElement.classList.add('no-motion');

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  function money(cents) {
    const str = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + str;
  }
  function toast(msg) {
    const t = $('#omToast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._t);
    t._t = setTimeout(() => t.classList.remove('show'), 2400);
  }

  /* ---------- smart nav ---------- */
  const nav = $('.site-header');
  if (nav) {
    let lastY = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y < 70) {
        nav.classList.remove('nav-hide', 'nav-float');
      } else {
        nav.classList.add('nav-float');
        if (y > lastY + 4) nav.classList.add('nav-hide');
        else if (y < lastY - 4) nav.classList.remove('nav-hide');
      }
      lastY = y;
    }, { passive: true });
  }

  /* ---------- reveals ---------- */
  if ('IntersectionObserver' in window && MOTION) {
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    $$('.rv').forEach((el) => io.observe(el));
  } else {
    $$('.rv').forEach((el) => el.classList.add('in'));
  }

  /* ---------- parallax ---------- */
  const plx = $$('[data-plx]');
  if (plx.length && MOTION) {
    let queued = false;
    const update = () => {
      queued = false;
      const vh = window.innerHeight;
      plx.forEach((el) => {
        const host = el.closest('.hero,.band,.im') || el.parentElement;
        const r = host.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        const p = (r.top + r.height / 2 - vh / 2) / vh;
        const s = parseFloat(el.dataset.plx) || 30;
        el.style.transform = 'translateY(' + (-p * s).toFixed(1) + 'px) scale(1.1)';
      });
    };
    window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- cart drawer ---------- */
  const drawer = $('#bagDrawer'), scrim = $('#bagScrim');
  function openBag() { if (drawer) { drawer.classList.add('on'); scrim.classList.add('on'); } }
  function closeBag() { if (drawer) { drawer.classList.remove('on'); scrim.classList.remove('on'); } }
  window.omOpenBag = openBag;
  if (scrim) scrim.addEventListener('click', closeBag);
  $$('.bag-x').forEach((b) => b.addEventListener('click', closeBag));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeBag(); });

  function lineHTML(item, index) {
    const img = item.image
      ? '<img class="bth" src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_128x$1$2') + '" alt="" loading="lazy">'
      : '<div class="bth"></div>';
    const variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    const isGwp = OM.gwpVariant && item.variant_id === OM.gwpVariant && item.final_line_price === 0;
    return '<div class="bline">' + img +
      '<div class="bi"><div class="bnm">' + item.product_title + '</div>' +
      (variantTitle ? '<div class="bsz">' + variantTitle + '</div>' : '') +
      (isGwp ? '<div class="bsz" style="color:var(--oil)">Gift with purchase</div>' :
        '<span class="bqty"><button data-qty="-1" data-line="' + index + '" aria-label="Decrease">−</button>' + item.quantity +
        '<button data-qty="1" data-line="' + index + '" aria-label="Increase">+</button></span>') +
      '</div><div class="bcol"><span class="bpr">' + (item.final_line_price === 0 ? 'Free' : money(item.final_line_price)) + '</span>' +
      '<button class="brm" data-rm="' + index + '">Remove</button></div></div>';
  }

  function renderBag(cart) {
    if (!drawer) return;
    const items = $('#bagItems'), foot = $('#bagFoot'), meter = $('#shipMeter'), title = $('#bagTitle');
    const links = $$('[data-bag-count]');
    links.forEach((l) => { l.textContent = 'Bag (' + cart.item_count + ')'; });
    title.textContent = cart.item_count ? 'Your bag (' + cart.item_count + ')' : 'Your bag';
    if (!cart.item_count) {
      meter.classList.add('hidden'); foot.classList.add('hidden');
      items.innerHTML = '<div class="bag-empty"><div class="e">Your bag is empty.</div>Your skin is waiting.<br><a href="/collections/all-products">Shop the shelf</a></div>';
      return;
    }
    meter.classList.remove('hidden'); foot.classList.remove('hidden');
    const sub = cart.items_subtotal_price;
    const away = Math.max(0, (OM.freeShip || 5000) - sub);
    meter.innerHTML = (away > 0 ? ("You're <b>" + money(away) + "</b> away from free shipping") : '<b>Free shipping unlocked</b>') +
      '<div class="smbar"><div class="smfill" style="width:' + Math.min(100, Math.round(sub / (OM.freeShip || 5000) * 100)) + '%"></div></div>';
    let html = cart.items.map((it, i) => lineHTML(it, i + 1)).join('');

    if (OM.gwpEnabled && OM.gwpVariant) {
      const hasGift = cart.items.some((it) => it.variant_id === OM.gwpVariant);
      const paidCount = cart.items.filter((it) => it.variant_id !== OM.gwpVariant).reduce((a, it) => a + it.quantity, 0);
      const gimg = OM.gwpImage ? '<img src="' + OM.gwpImage + '" alt="">' : '';
      if (paidCount >= (OM.gwpMin || 2) && !hasGift) {
        html += '<div class="gwp">' + gimg + '<div class="gt"><b>' + OM.gwpTitle + '</b>Your free gift is unlocked</div><button class="claim" data-claim>Claim it</button></div>';
      } else if (paidCount < (OM.gwpMin || 2) && !hasGift) {
        html += '<div class="gwp" style="opacity:.65">' + gimg + '<div class="gt"><b>' + OM.gwpTitle + '</b>Add one more product and it\'s yours, free</div><span class="free">Gift</span></div>';
      }
    }
    items.innerHTML = html;
    foot.innerHTML = '<div class="bsub"><span>Subtotal</span><span class="v">' + money(sub) + '</span></div>' +
      '<div class="bnote">' + (away > 0 ? ('Shipping calculated at checkout. Free over ' + money(OM.freeShip || 5000) + '.') : 'Shipping is on us.') + '</div>' +
      '<div class="bguar"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5 4.5 5.4v6.1c0 4.6 3.1 8.6 7.5 9.9 4.4-1.3 7.5-5.3 7.5-9.9V5.4L12 2.5z" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="m8.8 12.2 2.2 2.2 4.3-4.6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg><span><b>30-day money-back guarantee.</b> Don\'t love it? <a href="/policies/refund-policy">Full refund.</a></span></div>' +
      '<a class="bcheckout" href="/checkout">Checkout</a>';
  }

  function refreshBag(open) {
    fetch('/cart.js').then((r) => r.json()).then((c) => { renderBag(c); if (open) openBag(); });
  }

  function addToBag(variantId, qty, sellingPlan) {
    const payload = { id: variantId, quantity: qty || 1 };
    if (sellingPlan) payload.selling_plan = sellingPlan;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then((r) => {
      if (!r.ok) return r.json().then((e) => { throw e; });
      return r.json();
    }).then(() => refreshBag(true))
      .catch((e) => toast(e.description || 'Could not add to bag'));
  }
  window.omAddToBag = addToBag;

  document.addEventListener('click', (e) => {
    const nt = e.target.closest('[data-nav-toggle]');
    if (nt) {
      const h = document.querySelector('.site-header');
      const open = h.classList.toggle('nav-open');
      nt.setAttribute('aria-expanded', open);
      return;
    }
    const add = e.target.closest('[data-add-variant]');
    if (add) { e.preventDefault(); e.stopPropagation(); addToBag(parseInt(add.dataset.addVariant, 10)); return; }
    const claim = e.target.closest('[data-claim]');
    if (claim) { addToBag(OM.gwpVariant); return; }
    const qty = e.target.closest('[data-qty]');
    if (qty) {
      const line = parseInt(qty.dataset.line, 10);
      fetch('/cart.js').then((r) => r.json()).then((c) => {
        const q = c.items[line - 1].quantity + parseInt(qty.dataset.qty, 10);
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, q) }) });
      }).then(() => refreshBag(false));
      return;
    }
    const rm = e.target.closest('[data-rm]');
    if (rm) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: parseInt(rm.dataset.rm, 10), quantity: 0 }) })
        .then(() => refreshBag(false));
      return;
    }
    const bagLink = e.target.closest('[data-bag-open]');
    if (bagLink) { e.preventDefault(); refreshBag(true); }
  });
  refreshBag(false);

  /* ---------- PDP: variant pills + price + form submit ---------- */
  const form = $('#omProductForm');
  if (form) {
    const data = JSON.parse($('#omProductJSON').textContent);
    const priceEl = $('#omPrice'), idInput = form.querySelector('input[name="id"]'), addBtn = $('#omAddBtn');
    function currentVariant() {
      const checked = form.querySelector('input[name="om-size"]:checked');
      if (!checked) return data.variants[0];
      return data.variants.find((v) => String(v.id) === checked.value) || data.variants[0];
    }
    const planSelect = form.querySelector('#omPlanSelect');
    const planInput = form.querySelector('#omSellingPlan');
    const planFreq = form.querySelector('#omPlanFreq');
    function planMode() {
      const m = form.querySelector('input[name="om-plan-mode"]:checked');
      return m ? m.value : 'onetime';
    }
    function currentPlanId() {
      if (planMode() !== 'subscribe' || !planSelect) return null;
      return parseInt(planSelect.value, 10);
    }
    function allocationPrice(v, planId) {
      const alloc = (v.selling_plan_allocations || []).find((a) => a.selling_plan_id === planId);
      return alloc ? alloc.price : v.price;
    }
    function sync() {
      const v = currentVariant();
      idInput.value = v.id;
      const planId = currentPlanId();
      priceEl.textContent = money(planId ? allocationPrice(v, planId) : v.price);
      if (planInput) planInput.value = planId || '';
      if (planFreq) planFreq.classList.toggle('hidden', planMode() !== 'subscribe');
      const onePrice = form.querySelector('[data-popt-price="onetime"]');
      const subPrice = form.querySelector('[data-popt-price="subscribe"]');
      if (onePrice) onePrice.textContent = money(v.price);
      if (subPrice && planSelect) {
        const firstPlan = parseInt(planSelect.value, 10);
        subPrice.textContent = money(allocationPrice(v, firstPlan)) + ' each';
      }
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
    }
    form.addEventListener('change', sync);
    sync();
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      addToBag(parseInt(idInput.value, 10), 1, currentPlanId());
    });
  }

  /* ---------- PDP gallery ---------- */
  document.addEventListener('click', (e) => {
    const th = e.target.closest('[data-gal-src]');
    if (!th) return;
    const main = $('#omGalMain');
    if (main) main.src = th.dataset.galSrc;
    $$('.gal .thumbs button').forEach((b) => b.classList.remove('on'));
    th.classList.add('on');
  });

  /* ---------- pairs-with fallback: Shopify recommendations ---------- */
  const pairsGrid = $('#pairsGrid');
  if (pairsGrid && !pairsGrid.querySelector('.card')) {
    const pid = pairsGrid.dataset.productId;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=3&intent=related')
      .then((r) => r.json())
      .then((d) => {
        const prods = (d.products || []).slice(0, 3);
        if (!prods.length) { const mod = $('#pairsMod'); if (mod) mod.style.display = 'none'; return; }
        pairsGrid.innerHTML = prods.map((p) => {
          const v = p.variants && p.variants[0];
          const img = p.featured_image ? '<img loading="lazy" src="' + p.featured_image + '" alt="' + (p.title || '') + '">' : '';
          return '<div class="card in rv"><a class="cover" href="' + p.url + '" aria-label="' + p.title + '"></a>' +
            '<div class="ph">' + img + '</div>' +
            (v && v.available ? '<button class="quick" data-add-variant="' + v.id + '">Add to bag</button>' : '') +
            '<div class="info"><span class="nm">' + p.title.split(':')[0] + '</span>' +
            '<span class="pr">' + money(p.price) + '</span></div></div>';
        }).join('');
      })
      .catch(() => { const mod = $('#pairsMod'); if (mod) mod.style.display = 'none'; });
  }

  /* ---------- reviews read-more ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('#moreRevs');
    if (!btn) return;
    const hidden = $$('.rev-card.xtra.hidden');
    hidden.slice(0, 2).forEach((c) => c.classList.remove('hidden'));
    if (hidden.length <= 2) btn.classList.add('hidden');
  });
})();
